module.exports = "/fonts/gt-walsheim-black.ttf";